<div class="emma-unlimited-or-number-input">
    <emma-switch
        name="unlimited"
        [checked]="unlimited"
        (checkedChange)="onChangeUnlimited($event)"
        [disabled]="disabled"
        [label]="unlimitedLabel"
    ></emma-switch>
    <div class="subinput">
        <div *ngIf="!unlimited" [@fadeInOut] emma-label [label]="valueLabel">
            <emma-input
                name="value"
                type="number"
                inputmode="numeric"
                [(ngModel)]="value"
                [min]="min"
                [step]="step"
                [max]="max"
                [disabled]="disabled"
                [readonly]="readonly"
                ($blur)="onBlur()"
            ></emma-input>
        </div>
    </div>
</div>
